import React from "react";
import '../styles/semantic.min.css';
import Start from "./index";


export default () => <Start/>